module.exports = __webpack_public_path__ + "static/img/allegroFootprint.2419328b.png";